import { watch } from "vue";
import type { NuxtSSRContext, UseFetchOptions } from "#app";

export interface ResponseData {
  code: number;
  data: any;
  msg: string;
}

/**
 * @TIMEOUT 客户端超时时间
 * @SERVERTIMEOUT 服务端超时时间
 */
const TIMEOUT = 15000;
const SERVERTIMEOUT = 5000;

export const useHttp = async (
  request: string,
  opts?: (UseFetchOptions<any> & { reactive?: boolean }) | undefined
): Promise<any> => {
  let baseURL: string = useRuntimeConfig().public.apiBase;
  if (import.meta.server)
    baseURL = useRuntimeConfig().public.localApiBase || baseURL;

  if (!request.startsWith("http") && !request.startsWith("/api")) {
    if (request.startsWith("/")) {
      request = baseURL + request;
    } else {
      request = baseURL + "/" + request;
    }
  }
  const equipment = useEquipmentStore();
  const user = useUserStore();

  const appInfo = {
    ver: equipment.appConfig.version || "",
    pkg: equipment.appConfig.packageName || "",
    channel: equipment.appConfig.appChannel || "",
  };
  // console.log("usehttp request 3", request);
  let defaultParams = {};
  let defaultBody = {};

  if (!opts?.method || opts?.method === "GET" || opts?.method === "get") {
    defaultParams = appInfo;
  }

  defaultParams = {
    ...defaultParams,
    login_source: "sgw",
    inviter: user.inviterCode,
  };

  console.log("@@@ useHttp params inviterCode:", user.inviterCode);

  // if (equipment.webviewPlatform === WEBVIEW_PLATFORM.NONE) {
  //   defaultParams = { ...defaultParams, login_source: "sgw" };
  // } else if (equipment.webviewPlatform === WEBVIEW_PLATFORM.ANDROID) {
  //   defaultParams = { ...defaultParams, login_source: "android" };
  // } else if (equipment.webviewPlatform === WEBVIEW_PLATFORM.IOS) {
  //   defaultParams = { ...defaultParams, login_source: "ios" };
  // }

  if (opts?.method === "POST" || opts?.method === "post") {
    defaultBody = appInfo;
  }

  const headers:
    | Record<string, string>
    | [key: string, value: string][]
    | Headers = {};

  if (import.meta.client) {
    headers["sv-domain"] = location.host;
    headers["uuid"] = await getdeviceUuid();
  }
  if (import.meta.server) {
    const requestHeaders = useRequestHeaders(["host"]);
    const host = requestHeaders["host"];
    if (host) headers["sv-domain"] = host;
  }

  let svPlatform = "webapp";
  let svAppPackage = location?.host;
  let svAppVersion = "";
  if (equipment.webviewPlatform === WEBVIEW_PLATFORM.ANDROID) {
    svPlatform = "android";
    svAppPackage = equipment?.appConfig?.packageName;
    svAppVersion = equipment?.appConfig?.version;
  } else if (equipment.webviewPlatform === WEBVIEW_PLATFORM.IOS) {
    svPlatform = "ios";
    svAppPackage = equipment?.appConfig?.packageName;
    svAppVersion = equipment?.appConfig?.version;
  }
  const defaultHeaders = {
    "Svalue-Language": "en_US",
    "sv-platform": svPlatform, // webapp ios android
    "sv-reco-api": "webapp", // sv-reco-api  webapp
    "sv-app-package": svAppPackage, //  webapp
    "sv-app-version": svAppVersion, //  webapp
    ...headers,
  };

  // 这个好像不执行
  AbortSignal.timeout ??= function timeout(ms) {
    const ctrl = new AbortController();
    setTimeout(() => {
      console.error("http request get timeout", request);

      ctrl.abort();
    }, ms);
    return ctrl.signal;
  };
  // defalutOpt会被覆盖
  // 区分客户端和服务端timeout
  let timeout = import.meta.server ? SERVERTIMEOUT : TIMEOUT;

  const defalutOpt: UseFetchOptions<any> = {
    signal: AbortSignal.timeout(timeout),
    retry: import.meta.server ? 0 : 3,
  };
  const data = {
    ...defalutOpt,
    ...opts,
    params: { ...defaultParams, ...opts?.params },
    headers: { ...defaultHeaders, ...opts?.headers },
  };

  if (opts?.method === "POST" || opts?.method === "post") {
    if (opts.body instanceof FormData) data.body = opts.body;
    else data.body = { ...(opts?.body as object) };
  }
  console.log("request@@@", request);
  if (opts?.reactive) {
    return useFetch(request, data);
  } else {
    return new Promise(async (resolve, reject) => {
      useFetch<ResponseData>(request, data)
        .then(({ data: res, error, pending, refresh }) => {
          watch(
            pending,
            (val) => {
              if (!val) {
                if (res.value) {
                  if (res.value.code !== 0) {
                    reject(unref(res));
                  } else {
                    resolve({ res: unref(res) });
                  }
                } else {
                  if (!error.value) {
                    reject("http request get null value");
                  }
                }
                if (error.value) {
                  // 这是个H3error对象
                  console.error(toValue(error.value), import.meta.client);

                  reject(unref(error));
                }
              }
            },
            {
              immediate: true,
            }
          );
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};

//统一封装fetch
export const useCustomizeFetch = (request: string, options?: any) => {
  return fetch(request, {
    ...options,
  });
};
